<template>
  <span>
    {{this.dateT()}}
  </span>
</template>

<script>
var moment = require('moment');
export default {
  props: ['data', 'index'],
  data: function () {
    return {
    };
  },
  methods: {
    dateT: function () {
      return this.randomDate(new Date(1925, 0, 1), new Date(2018, 0, 1));
    },
    randomDate: function (start, end) {
      return moment(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Modules/Table/DateT.vue